"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _excluded = ["className", "buttonContainerClassName", "disabled", "id", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Toggle = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    buttonContainerClassName = _ref.buttonContainerClassName,
    disabled = _ref.disabled,
    id = _ref.id,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useInputValidation = (0, _utils.useInputValidation)(props),
    checked = _useInputValidation.checked;
  var toggleOutlineStyles = 'w-[46px] h-[26px] rounded-[24px]';
  var transitionStyles = 'transition duration-300';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('relative', className)
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    id: id,
    type: "checkbox",
    disabled: disabled,
    ref: ref,
    checked: checked,
    onChange: onChange,
    className: (0, _classnames.default)('peer toggle-peer', 'opacity-0 border-none absolute top-0 left-0', toggleOutlineStyles, 'cursor-pointer disabled:cursor-not-allowed')
  }, props, {
    value: props.value || false
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(toggleOutlineStyles, transitionStyles, 'toggle p-[3px]', {
      'bg-grey-30 peer-focus:bg-grey-40 peer-checked:bg-green1-55 peer-checked:peer-focus:bg-green1-65': !disabled
    }, {
      'bg-grey-15 peer-checked:bg-green1-30': disabled
    }, buttonContainerClassName)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('toggle-button bg-white rounded-full h-[20px] w-[20px]', 'transition duration-300', {
      'transform translate-x-full': checked
    }, {
      'cursor-pointer': !disabled
    }, {
      'cursor-not-allowed': disabled
    })
    // When the translate function is applied,
    // the button is given a new stacking context,
    // which puts it above the absolutely positioned hidden checkbox input.
    // Button also needs an onClick handler so that user can still click on
    // it when checked is true
    ,
    onClick: onChange
  })));
});
exports.Toggle = Toggle;